import constants from "../../core/constants";
import cashCollectionDialogCtrl from "./cashCollectionDiag/cashCollectionDialog.controller";
import cashCollectionDialog from "./cashCollectionDiag/cashCollectionDialog.html";
import isNil from "lodash/fp/isNil";
import { sumByProp } from "../../core/utils";
import { saveAs } from "file-saver";

class Controller {
  constructor($injector, $stateParams, $mdDialog, $location, $anchorScroll) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Bookings = $injector.get("Bookings");
    this.BookingTransforms = $injector.get("BookingTransforms");
    this.bookingStatus = $injector.get("Lists").all.bookingStatus;
    this.sections = $injector.get("Sections").bookingsSections;
    this.$location = $location;
    this.$anchorScroll = $anchorScroll;
    this.User = $injector.get("User");
    this.updateBookingEvent = this.Events.getUpdateEvent("booking");
    this.transactionsValue = [
      "Credits Amount",
      "Card Amount",
      "Debt Amount",
      "Sub Total",
      "Promotion",
      "Package Discount",
      "Total",
    ];
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    const getBooking = () => {
      this.Bookings.get(this.$stateParams.id).$promise.then((response) => {
        this.booking = this.BookingTransforms.justify(response);
        if (this.booking.transactions.length > 0) this.createVisualReceipt();
        if (this.booking.cash_collection_meta) {
          this.cashCollectionMeta = this.booking.cash_collection_meta;
          this.User.get(this.cashCollectionMeta.operator).$promise.then(
            (user) => {
              this.operatorName = user.name;
            }
          );
        }

        if (!isNil(this.booking.cancellation_date.value)) {
          // If booking is cancelled
          if (
            !isNil(this.booking.cancelled_by) &&
            this.booking.cancelled_by.role === "agent"
          ) {
            this.User.get(this.booking.cancelled_by.id).$promise.then(
              (user) => {
                this.UserName = user.name;
              }
            );
          } else if (!isNil(this.booking.cancellation_reason)) {
            switch (this.booking.cancellation_reason.value) {
              case "late_captain":
                this.cancellationReason = "The Captain was Late";
                break;
              case "timing_not_suitable":
                this.cancellationReason = "The timing was not suitable";
                break;
              case "change_booking":
                this.cancellationReason =
                  "The Customer wanted to change the booking details";
                break;
              case "captain_out_of_reach":
                this.cancellationReason =
                  "The Customer couldn't reach the captain";
                break;
              case "captain_bus_mismatch":
                this.cancellationReason =
                  "Captain/Bus didn't match description";
                break;
              case "change_in_plans":
                this.cancellationReason = "Change in plans";
                break;
              case "othe":
                this.cancellationReason = "Other";
                break;
              default:
                break;
            }
          }
        }
      });
    };
    const onUpdate = (options) => {
      const params = {};
      params[options.key] = options.value;

      this.Bookings.update(this.$stateParams.id, params).$promise.then(() => {
        this.booking[options.key].isDisabled = true;
        this.Events.emit(
          this.successNotificationEvent,
          this.Messages.updateMessage("booking")
        );
      });
    };

    getBooking();

    this.cancelRefund = () => {
      const cancel = this.$mdDialog
        .confirm()
        .title(
          `Are you sure you want to cancel and refund "${this.booking.user.name}" booking?`
        )
        .ok("Ok")
        .cancel("Cancel");

      this.$mdDialog.show(cancel).then(
        () => {
          const model = { refund_percentage: constants.refundPercentage };

          this.Bookings.cancel(this.$stateParams.id, model).$promise.then(
            () => {
              this.Events.emit(
                this.successNotificationEvent,
                this.Messages.cancelRefundMessage()
              );
              getBooking();
            },
            (response) =>
              this.Events.emit(this.errorNotificationEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.resolveCashCollection = () => {
      this.$mdDialog.show({
        controller: cashCollectionDialogCtrl,
        controllerAs: "$ctrl",
        template: cashCollectionDialog,
        locals: {
          id: this.booking._id.value,
          cashCollectionMeta: this.cashCollectionMeta,
        },
      });
    };

    this.Events.on(this.updateBookingEvent, onUpdate);
  }

  downloadInvoicePdf() {
    this.Bookings.downloadInvoicePdf(this.$stateParams.id).$promise.then(
      (response) => {
        saveAs(response.url);
      }
    );
  }

  createVisualReceipt() {
    const transactionsList = this.booking.transactions;
    const firstTransaction = transactionsList[0] || {};
    const numberOfSeats = this.booking.seat_count.value;
    let farePerSeat = firstTransaction.subTotal;
    if (numberOfSeats > 1 && transactionsList.length === 1) {
      farePerSeat /= numberOfSeats;
    }
    const totalFare = numberOfSeats * farePerSeat;
    const promotionAmount = sumByProp(transactionsList, "promotionDeduction");
    const packageAmount = this.booking.receipt.commuter_package_discount;

    const finalFare =
      totalFare -
      promotionAmount -
      packageAmount +
      this.booking.receipt.reschedule_fee +
      " " +
      this.booking.currency.value;

    const creditsAmount = sumByProp(transactionsList, "creditsAmount");
    const cardAmount = sumByProp(transactionsList, "cardAmount");
    const cashAmount = `${sumByProp(transactionsList, "debtAmount")} ${
      this.booking.currency.value
    }`;
    const mpesaAmount = sumByProp(transactionsList, "mpesaAmount");
    const serviceFeeApplied = sumByProp(transactionsList, "serviceFeeApplied");

    this.visualReceipt = {
      numberOfSeats,
      farePerSeat,
      totalFare,
      promotionAmount,
      packageAmount,
      finalFare,
      creditsAmount,
      cardAmount,
      cashAmount,
      mpesaAmount,
      serviceFeeApplied,
      rescheduleFee: this.booking.receipt.reschedule_fee,
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/booking/booking.controller.js